import React, { Component } from 'react';
import QR_Scanner_Box from '../../Images/QRScanner/qr_scanner_box.png';
import Flash_On from '../../Images/QRScanner/flash_on.png';
import Flash_Off from '../../Images/QRScanner/flash_off.png';
import Reverse_Camera from '../../Images/QRScanner/reverse_camera.png';
import Close from '../../Images/QRScanner/close.png';

export default class QRScanner_Controls extends Component {
	constructor(props) {
		super(props);
		this.state = {
			is_flash_enabled: false,
			is_use_front_camera: false,
		}
	}

	handleClose = () => {
		this.resetControls();
		window.app.content_area.current.switch_content.current.hideQRScanner();
		if (this.props.param.from != 'DLinkAddCamera') {
			window.app.content_area.current.content_handler(this.props.param.from, { from: this.props.param.original_from });
		} else {
			window.app.content_area.current.switch_content.current.handleShowBottomControls();
		}
	}

	resetControls = () => {
		this.setState({
			is_flash_enabled: false,
			is_use_front_camera: false,
		})
	}

	handleToggleFlash = () => {
		if (!this.state.is_flash_enabled) {
			if (!this.state.is_use_front_camera) {
				this.setState({ is_flash_enabled: true })

				window.QRScanner.enableLight(function (err, status) {
					err && console.error(err);
					console.log(status);
				});
			}
		} else {
			this.setState({ is_flash_enabled: false })

			window.QRScanner.disableLight(function (err, status) {
				err && console.error(err);
				console.log(status);
			});
		}
	}

	handleReverseCamera = () => {
		if (!this.state.is_use_front_camera) {
			this.setState({ is_use_front_camera: true })
			this.setState({ is_flash_enabled: false })

			window.QRScanner.useFrontCamera(function (err, status) {
				err && console.error(err);
				console.log(status);
			});
		} else {
			this.setState({ is_use_front_camera: false })

			window.QRScanner.useBackCamera(function (err, status) {
				err && console.error(err);
				console.log(status);
			});
		}
	}

	render() {
		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: '100%',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center'
		}

		let close_button_img_style = {
			width: 20,
			marginTop: 10,
			marginLeft: 10,
		}

		let close_button_style = {
			position: 'absolute',
			right: 20,
			top: 20,
			background: '#c6c6c6',
			borderRadius: 20,
			width: 40,
			height: 40,
		}

		let bottom_controls_style = {
			textAlign: 'center',
			marginTop: 400,
		}

		let flash_button_style = {
			background: this.state.is_flash_enabled ? '#0098de' : '#c6c6c6',
			borderRadius: 35,
			width: 70,
			height: 70,
			display: 'inline-block',
			margin: 20,
		}

		let reverse_button_style = {
			background: this.state.is_use_front_camera ? '#0098de' : '#c6c6c6',
			borderRadius: 35,
			width: 70,
			height: 70,
			display: 'inline-block',
			margin: 20,
		}

		let flash_button_img_style = {
			width: 50,
			marginTop: 10,
			marginLeft: 5,
		}

		let reverse_button_img_style = {
			width: 50,
			marginTop: 10,
		}

		return (
			<div>
				<div style={main_content_style} className='slideInDown'>
					<div style={close_button_style} onClick={this.handleClose}>
						<img src={Close} style={close_button_img_style} />
					</div>

					<div>
						{/* QR Scanner Box */}
						{/*}<div style={{ textAlign: 'center'}}>
							<img src={QR_Scanner_Box} />
		        		</div>*/}
						{/* QR Scanner Controls */}
						<div style={bottom_controls_style}>
							<div style={flash_button_style} onClick={this.handleToggleFlash}>
								<img src={this.state.is_flash_enabled ? Flash_On : Flash_Off} style={flash_button_img_style} />
							</div>
							<div style={reverse_button_style} onClick={this.handleReverseCamera}>
								<img src={Reverse_Camera} style={reverse_button_img_style} />
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}